import { Component, OnDestroy, OnInit } from '@angular/core';
import { trackByRef } from 'src/app/lego-utils';
import { Subscription } from 'rxjs';
import { MyWorklistService } from 'src/app/state';

@Component({
  selector: 'em-worklist',
  templateUrl: './worklist.component.html',
  standalone: false,
})
export class WorklistComponent implements OnInit, OnDestroy {
  public readonly trackByRef = trackByRef;
  public worklistItems$ = this.worklistItemService.worklistItems$;
  public error$ = this.worklistItemService.error$;
  public isWorklistLoading$ = this.worklistItemService.loading$;

  private readonly subscription = new Subscription();

  public constructor(private readonly worklistItemService: MyWorklistService) {}

  public ngOnInit(): void {
    this.subscription.add(this.worklistItemService.loadWorklistItems().subscribe());
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
